import actionTypes from "_constants/actionTypes";

export const dataActions = {
  endTransaction,
  getCountries,
  getProvinces,
  getCities,
  getCourses,
  getProfessions,
  getProvincesCountry,
};

function endTransaction() {
  return {
    type: actionTypes.END_TRANSACTION,
  };
}

function getCourses() {
  return {
    type: actionTypes.GET_COURSES,
  };
}

function getCountries() {
  return {
    type: actionTypes.GET_COUNTRIES,
  };
}

function getProvincesCountry(payload) {
  return {
    type: actionTypes.GET_PROVINCESCOUNTRY,
    payload: payload,
  };
}

function getProvinces() {
  return {
    type: actionTypes.GET_PROVINCES,
  };
}

function getCities() {
  return {
    type: actionTypes.GET_CITIES,
  };
}

function getProfessions() {
  return {
    type: actionTypes.GET_PROFESSIONS,
  };
}
